"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var table_1 = require("antd/lib/table");
var FontAwesome_1 = require("../../../../../../../../shared/components/icons/FontAwesome");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableActionEdit_1 = require("../../../../../../../../shared/components/table_actions/TableActionEdit");
var BonusTournamentMinBetsList = /** @class */ (function (_super) {
    __extends(BonusTournamentMinBetsList, _super);
    function BonusTournamentMinBetsList(props) {
        return _super.call(this, props) || this;
    }
    BonusTournamentMinBetsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0,
        }, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key);
            _this.props.state.setExtBreadCrumbPath(["Минимальные суммы ставок"]);
        });
    };
    BonusTournamentMinBetsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BonusTournamentMinBetsList.prototype.getColumns = function () {
        var _this = this;
        return ([{
                title: 'Турнир',
                dataIndex: this.props.data.dk_app_currency_id,
                key: this.props.data.dk_app_currency_id,
                width: 150,
                render: function (text, record, idx) {
                    return React.createElement("div", null,
                        React.createElement(FontAwesome_1.FA, { right: true, icon: "registered" }),
                        " ",
                        _this.props.rootRecord.title);
                }
            }, {
                title: 'Валюта',
                dataIndex: this.props.data.dk_app_currency_title,
                key: this.props.data.dk_app_currency_title,
                width: 150
            }, {
                title: 'Сумма',
                dataIndex: this.props.data.dk_amount,
                key: this.props.data.dk_amount,
                width: 150
            }, {
                title: 'Комментарий',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                width: 200
            }, {
                title: 'Добавлена',
                dataIndex: this.props.data.dk_date_added2,
                key: this.props.data.dk_date_added2,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added2.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: 'Изменена',
                dataIndex: this.props.data.dk_date_changed2,
                key: this.props.data.dk_date_changed2,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_changed2.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditPlayerClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeletePlayerClick(record); } }))); },
                width: 100
            }
        ]);
    };
    BonusTournamentMinBetsList.prototype.onDeletePlayerClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u0417\u0430\u043F\u0438\u0441\u044C \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430"));
        });
    };
    BonusTournamentMinBetsList.prototype.onEditPlayerClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    BonusTournamentMinBetsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.rootRecord.key);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    BonusTournamentMinBetsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(table_1.default, { bordered: true, columns: this.getColumns(), dataSource: this.state.data, locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, pagination: {
                    pageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) { return React.createElement("div", { style: { margin: 0 } },
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                        " [",
                        record.date_added2.format(_this.props.state.getDateTimeFormat()),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                        " [",
                        record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                        "]")); } })));
    };
    return BonusTournamentMinBetsList;
}(React.Component));
exports.default = BonusTournamentMinBetsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/options/min_bets/BonusTournamentMinBetsList.tsx
// module id = 2532
// module chunks = 0